import type { IButtonBaseProps } from '@sixui/ui';
import { ButtonBase } from '@sixui/ui';
import { focusRingTokens } from '@sixui/ui/components/FocusRing/FocusRing.stylex';
import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import { shapeTokens } from '@sixui/ui/themes/base/shape.stylex';
import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type IBreadcrumbsActionProps = IContainerProps &
  Pick<IButtonBaseProps, 'href' | 'onClick' | 'disabled'> & {
    children?: React.ReactNode;
    current?: boolean;
  };

const styles = stylex.create({
  inner: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.375rem',
    alignItems: 'center',
  },
});

const buttonStyles = stylex.create({
  host: {
    overflow: 'hidden',
    borderRadius: shapeTokens.corner$xs,
    paddingTop: '0.25rem',
    paddingBottom: '0.25rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    color: colorSchemeTokens.onSurfaceVariant,
  },
  host$current: {
    color: colorSchemeTokens.onSurface,
  },
});

const buttonFocusRingStyles = stylex.create({
  host: {
    [focusRingTokens.shape]: shapeTokens.corner$xs,
  },
});

export const BreadcrumbsAction: React.FC<IBreadcrumbsActionProps> = ({
  sx,
  children,
  current,
  ...buttonProps
}) => (
  <ButtonBase
    sx={[current ? buttonStyles.host$current : null, sx ?? null]}
    styles={buttonStyles}
    innerStyles={{
      focusRing: buttonFocusRingStyles,
    }}
    inwardFocusRing
    {...buttonProps}
  >
    <div {...stylex.props(styles.inner)}>{children}</div>
  </ButtonBase>
);
